import {
  CitizensAgreementReact,
  FrontierAgreementReact,
  PeoplesAgreementReact,
  MakeItRingAgreementReact,
  FreedomAgreementReact,
  Financial111AgreementReact,
} from "@pay-path/agreements";

// Map of agreement keys to their corresponding React components
const AGREEMENT_COMPONENTS = {
  CITIZENS: CitizensAgreementReact,
  FRONTIER: FrontierAgreementReact,
  PEOPLES: PeoplesAgreementReact,
  MAKEITRING: MakeItRingAgreementReact,
  FINANCIAL111: Financial111AgreementReact,
  FREEDOM: FreedomAgreementReact,
};

/**
 * Get the appropriate Agreement component based on the agreement key
 * @param {string} agreementKey - The agreement key (e.g., 'CITIZENS', 'FRONTIER')
 * @returns {React.Component} The corresponding Agreement component, defaults to FrontierAgreementReact
 */
export const getAgreementComponent = (agreementKey) => {
  return AGREEMENT_COMPONENTS[agreementKey] || FrontierAgreementReact;
};

/**
 * Create an Agreement element with the provided props
 * @param {string} agreementKey - The agreement key
 * @param {Object} props - Props to pass to the agreement component
 * @returns {React.Element} The Agreement component element
 */
export const createAgreementElement = (agreementKey, props) => {
  const AgreementComponent = getAgreementComponent(agreementKey);
  return <AgreementComponent {...props} />;
};
